import { ReactNode, useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { OasisBackendProvider } from "../../hooks/useOasisBackend";
import { useUser } from "../../hooks/useUser";
import BACKEND_URL from "../config";

export const RequireAdminLogin: React.FC<{ children?: ReactNode }> = (props) => {
  const userApi = useUser();
  const [isAdminUser, setIsAdminUser] = useState<boolean | null>(null);

  useEffect(() => {
    if (userApi.state === "LoggedIn") {
      fetch(`${BACKEND_URL}/vnog/is_admin_user/`, {
        method: 'GET',
        credentials: 'include',
      })
      .then(response => response.json())
      .then(data => setIsAdminUser(data.is_admin_user))
      .catch(error => {
        console.log('Error checking admin status:', error);
        setIsAdminUser(false);
      });
    }
  }, [userApi.state]);

  if (userApi.state === "LoggedOut") return <Navigate to={"/login"} />;
  if (isAdminUser === null) return <div>Checking admin permissions...</div>;
  if (!isAdminUser) return <Navigate to={"/home"} />;
  
  return <OasisBackendProvider children={props.children} />;
}
